import { Cube } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCube12Line = createIcon(Cube, 12, "Line");
export const IconCube16Line = createIcon(Cube, 16, "Line");
export const IconCube20Line = createIcon(Cube, 20, "Line");
export const IconCube24Line = createIcon(Cube, 24, "Line");
export const IconCube32Line = createIcon(Cube, 32, "Line");
export const IconCube48Line = createIcon(Cube, 48, "Line");
export const IconCube64Line = createIcon(Cube, 64, "Line");
